<template>
  <div>
    <Header>
      Fryzjerzy
      <template #right>
        <b-button variant="primary" size="sm" @click="$inertia.visit(route('barbers.create'))">
          <b-icon icon="plus" />
        </b-button>
      </template>
    </Header>

    <b-table-simple :responsive="true" small class="table-vcenter">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Lp.</b-th>
          <b-th>Fryzjer</b-th>
          <b-th><b-icon icon="info-circle" /></b-th>
          <b-th>#</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="barber in barbers" :key="barber.id">
          <b-td>
            <span v-if="barber.deleted_at">
              <b-icon icon="x-circle" class="text-danger" />
            </span>
            <span v-else-if="barber.is_visible">
              {{ barber.priority }}
            </span>
            <span v-else>
              <b-icon icon="eye-slash-fill" class="text-muted" />
            </span>
          </b-td>
          <b-td>
            <inertia-link :href="route('barbers.edit', barber.id)">
              <b-avatar
                :src="barber.photo_url"
                variant="primary"
                :rounded="true"
                size="4em"
              />
            </inertia-link>
            <span class="ml-2">
              <span v-if="!barber.deleted_at">
                {{ barber.name }}
              </span>
              <span v-else>
                <del>{{ barber.name }}</del>
              </span>
            </span>
          </b-td>
          <b-td>
            <b-icon v-if="barber.is_online" icon="globe2" class="text-primary" />
            <b-icon v-else icon="telephone-fill" class="text-warning" />
          </b-td>
          <b-td>
            <inertia-link
              :href="route('barbers.edit', barber.id)"
              as="b-button"
              variant="outline-primary"
              size="sm"
            >
              <b-icon icon="pencil-fill" />
            </inertia-link>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'

export default {
  layout: Layout,
  components: {
    Header,
  },
  props: {
    barbers: Array,
  },
}
</script>
